import createSpinner from "../../../../../Shared/Functions/createSpinner";

export default /*@ngInject*/ function (entity, allEntityFieldsList, $uibModalInstance, helperService) {

    const vm = this;

    vm.entity = entity;
    vm.allEntityFieldsList = allEntityFieldsList;
    vm.saveSettings = saveSettings;
    vm.helperService = helperService;
    vm.cancel = cancel;

    activate();

    async function activate() {
        if (vm.allEntityFieldsList.every(field => field.Id !== -1)) {
            vm.allEntityFieldsList.unshift({ FieldName: ' -- Select a Source Metadata Field --', Id: -1, SourceMetadataEntityName: null });
        }
        vm.allEntityFieldsList.forEach(field => {
            if (field.Id === -1) {
                field.DisplayName = field.FieldName;
            } else {
                field.DisplayName = field.FieldName + ' - ' + field.SourceMetadataEntityName;
            }
        });
        if (!vm.entity.SourceMetadataFieldIdForLoopLookup) {
            vm.entity.SourceMetadataFieldForLoopLookup = vm.allEntityFieldsList[0];
        } else {
            vm.entity.SourceMetadataFieldForLoopLookup = vm.allEntityFieldsList.find(field => field.Id === vm.entity.SourceMetadataFieldIdForLoopLookup);
        }
        if (vm.entity.StaticPayload) {
            let parsedValue = JSON.parse(vm.entity.StaticPayload);
            if (typeof parsedValue === 'string') {
                vm.entity.StaticPayload = parsedValue;
            }
            else {
                vm.entity.StaticPayload = vm.entity.StaticPayload;
            }
        }
        else {
            vm.entity.StaticPayload = null;
        }
    }
    async function saveSettings() {
        vm.pleaseWait = new createSpinner();

        if (vm.entity.SourceMetadataFieldForLoopLookup?.Id === -1) {
            vm.entity.SourceMetadataFieldForLoopLookup.Id = null;
            vm.entity.SourceMetadataFieldForLoopLookup.FieldName = null;
            vm.entity.SourceMetadataFieldForLoopLookup.DisplayName = null;
            vm.entity.SourceMetadataFieldIdForLookupName = null;
        }

        vm.entity.SourceMetadataFieldIdForLoopLookup = vm.entity.SourceMetadataFieldForLoopLookup?.Id ? vm.entity.SourceMetadataFieldForLoopLookup.Id : null;

        try {
            await helperService.successfulSaveButton(vm.pleaseWait);
            $uibModalInstance.close(vm.entity);
        } catch (err) {
            vm.pleaseWait.loadingValue = false;
        }
    }

    function cancel() { $uibModalInstance.dismiss(); }

}